var exports = {
  "kL": "BaseAvatar.module__container___cTc5OH",
  "vk": "BaseAvatar.module__clickable___cTc5OH",
  "Lw": "BaseAvatar.module__overlay___cTc5OH",
  "Sl": "BaseAvatar.module__image___cTc5OH",
  "k8": "BaseAvatar.module__defaultTone___cTc5OH",
  "vW": "BaseAvatar.module__defaultToneMark___cTc5OH",
  "qf": "BaseAvatar.module__placeholder___cTc5OH",
  "ci": "BaseAvatar.module__placeholderFastFade___cTc5OH",
  "Ap": "BaseAvatar.module__placeholderVisible___cTc5OH",
  "uR": "BaseAvatar.module__placeholderHidden___cTc5OH",
  "n_": "BaseAvatar.module__hoverOverlay___cTc5OH",
  "II": "BaseAvatar.module__statusContainer___cTc5OH",
  "mH": "BaseAvatar.module__statusTooltipDisabled___cTc5OH",
  "VN": "BaseAvatar.module__reducedMotion___cTc5OH",
  "BC": "BaseAvatar.module__animatedMaskShape___cTc5OH",
  "Qb": "BaseAvatar.module__animatedMaskReducedMotion___cTc5OH",
  "AP": "BaseAvatar.module__typingBubble___cTc5OH",
  "y5": "BaseAvatar.module__typingDots___cTc5OH",
  "BI": "BaseAvatar.module__typingDot___cTc5OH",
  "Zm": "BaseAvatar.module__blink___cTc5OH",
  "fQ": "BaseAvatar.module__customStatusBadge___cTc5OH",
  "Bp": "BaseAvatar.module__customStatusBadgeBackground___cTc5OH",
  "Go": "BaseAvatar.module__customStatusBadgeContent___cTc5OH",
};

module.exports = exports;
